import FoodCategory from '@components/offer/models/FoodCategory';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodCategoryBaseListItem from './FoodCategoryBaseListItem';
import FoodCategoryName from './FoodCategoryName';

interface FoodCategoryListItemProps {
    foodCategory: FoodCategory;
    onClick: (foodCategory: FoodCategory) => void
}

const FoodCategoryListItem: React.FC<FoodCategoryListItemProps> = observer(({ foodCategory, onClick }) => {
    return (
        <FoodCategoryBaseListItem foodCategory={foodCategory} onClick={onClick}>
            <Grid padding={1.5} container direction="row" justifyContent="flex-start" alignItems="center">
                <img
                    src={require(`../../../../../assets/offer/food-category/${foodCategory.iconName}.png`)}
                    height={24} />
                <FoodCategoryName foodCategory={foodCategory} />
            </Grid>
        </FoodCategoryBaseListItem>
    )
})

export default FoodCategoryListItem;